import { shallowEqual } from "react-redux";
import { enablePdf, getTradeInAemPdfHtmlUrl } from "../utils/utils";
import { trackOpenPdf } from "../utils/tracking";
import { printPdf } from "../../common-deprecated/utils/pdfUtils";
import { useTradeInAemSelector } from "../redux/store";
import { useTradeInCsl } from "../csl/tradeInCslUtils";
import useTrackingParams from "./useTrackingParams";

type UseTradeInPdfType = {
    showPdfButton: boolean;
    onPrint: () => void;
};

const useTradeInPdf = (): UseTradeInPdfType => {
    const csl = useTradeInCsl();
    const vehicleValue = useTradeInAemSelector(csl.vehicleValueSelector, shallowEqual);
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const tradeInAemSettings = useTradeInAemSelector((state) => state.tradeInAemSettings);
    const tradeInAemModelSelect = useTradeInAemSelector((state) => state.tradeInAemModelSelect);
    const trackingParams = useTrackingParams();

    // The PDF button is not shown when hideValuationValueOnSummary is true because the PDF contains the valuation value
    const showPdfButton =
        enablePdf(commonSettings, tradeInAemSettings) && !!vehicleValue?.quoteId && !csl.hideValuationValueOnSummary;

    const onPrint = (): void => {
        if (vehicleValue?.quoteId) {
            trackOpenPdf(trackingParams, tradeInAemModelSelect);
            const pdfUrl = getTradeInAemPdfHtmlUrl(commonSettings, vehicleValue.quoteId);
            printPdf(pdfUrl, commonSettings);
        }
    };

    return { showPdfButton, onPrint };
};

export default useTradeInPdf;
